'use strict';

export class Time {

    constructor (data) {
        this.data = data;
    }

    #tick() {
        const d = new Date();
        this.utc = d.getTime() + (d.getTimezoneOffset() * 60000);

        this.time = new Date(this.utc + (1000* this.data.timezone));
        this.minutes = this.time.getMinutes();
        if (this.minutes < 10) this.minutes = `0${this.time.getMinutes()}`;
        this.hours = this.time.getHours();
    }

    get getCurrentTime() {
        this.#tick();
        return `${this.hours} : ${this.minutes}`;
    }

    get getCurrentTimeMilliseconds() {
        this.#tick();
        return this.time.getTime();
    }

    getDayTimeLine() {
        const TIME_THRESHOLD = 2;
        const oneHour = 3600000;

        this.#tick();

        let sunriseTime = new Date(this.data.sys.sunrise * 1000);
        let sunsetTime = new Date(this.data.sys.sunset * 1000);

        const currentTime = this.time.getTime();
        const sunrise = sunriseTime.getTime() + (sunriseTime.getTimezoneOffset() * 60000) + this.data.timezone * 1000;
        const beforeSunrise = sunrise - TIME_THRESHOLD * oneHour;
        const afterSunrise = sunrise + TIME_THRESHOLD * oneHour;
        const sunset = sunsetTime.getTime() + (sunsetTime.getTimezoneOffset() * 60000) + this.data.timezone * 1000;
        const zenit = (sunrise + sunset) / 2;
        const beforeSunset = sunset - TIME_THRESHOLD * oneHour;
        const afterSunset = sunset + TIME_THRESHOLD * oneHour;
        
        const dayStart = new Date(currentTime).setHours(0,0,0,0);
        const dayEnd = new Date(currentTime).setHours(23,59,59,0);
        // const dayStart = sunrise - oneHour;
        // const dayEnd = sunset + oneHour;

        return {
            currentTime,
            dayStart,
            beforeSunrise,
            sunrise,
            afterSunrise,
            beforeSunset,
            sunset,
            zenit,
            afterSunset,
            dayEnd
        };
    }

}